import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { patchUrlMappings } from '@discord/embedded-app-sdk'
import { App } from './App'
import './styles.css'

const proxyTarget = import.meta.env.VITE_ACTIVITY_PROXY_TARGET?.trim()
if (import.meta.env.VITE_ACTIVITY_USE_DISCORD_PROXY === 'true' && proxyTarget) {
  // The mapping must also be configured in the Discord Developer Portal. It
  // keeps API and WebSocket calls inside Discord's isolated Activity proxy.
  patchUrlMappings([{ prefix: '/activity', target: proxyTarget }])
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
